module.exports = __webpack_public_path__ + "img/img-49f187.png";